const processInclude = require('base/util');

processInclude(require('./animations/desplazamiento'));
processInclude(require('./animations/dropDownCheck').init());
